import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Message } from 'semantic-ui-react'

import TeamActions from 'Redux/TeamRedux'

class TrialMessage extends PureComponent {
  componentDidMount () {
    this.props.teamsListRequest()
  }

  render () {
  	const { teams } = this.props

  	if(teams.length) {
      const currTeam = teams[0]
      if(!currTeam.subscription) {
        return (
          <Message color={currTeam.trial.color}>
            {currTeam.trial.message}
          </Message>
        )
      }
  	}

  	return null
  }
}

const mapStateToProps = (state) => ({
  teams: state.teams.listData
})

const mapDispatchToProps = (dispatch) => ({
  teamsListRequest: () => dispatch(TeamActions.teamsListRequest())
})

export default connect(mapStateToProps, mapDispatchToProps)(TrialMessage)



// WEBPACK FOOTER //
// ./src/Components/TrialMessage.js